import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "pb-3 text-sm" }
const _hoisted_2 = { className: "link" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_4 = { className: "link" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_6 = { className: "link" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_8 = { class: "p-4 bg-gradient-to-b from-gray-50 dark:from-gray-900 to-gray-100 dark:to-gray-850 rounded-lg" }
const _hoisted_9 = { class: "text-sm" }
const _hoisted_10 = { class: "align-middle" }

import { ref } from 'vue';

import WalletButton from '@/components/web3/WalletButton.vue';
import { EXTERNAL_LINKS } from '@/constants/links';
import { SupportedWallets } from '@/services/web3/web3.plugin';

interface Props {
  isVisible?: boolean;
  onShowThirdParty: () => void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    isVisible: { type: Boolean, default: false },
    onShowThirdParty: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as { isVisible: boolean, onShowThirdParty: () => void }





const wallets = ref(SupportedWallets.filter(id => id !== 'gnosis'));

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BalLink = _resolveComponent("BalLink")!
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalModal = _resolveComponent("BalModal")!

  return (_openBlock(), _createBlock(_component_BalModal, {
    show: props.isVisible,
    title: "Connect to a wallet",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, [
        _createTextVNode(_toDisplayString(_ctx.$t('byConnectingWallet')) + " ", 1),
        _createVNode(_component_router_link, {
          to: { name: 'terms-of-use' },
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('policies.termsOfUse')), 1),
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: { name: 'cookies-policy' },
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('policies.cookiesPolicy')), 1)
          ]),
          _: 1
        }),
        _hoisted_5,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('useOf')) + " ", 1),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.onShowThirdParty && __props.onShowThirdParty(...args)))
        }, [
          _createVNode(_component_BalLink, null, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('policies.thirdPartyServices')), 1)
            ]),
            _: 1
          })
        ]),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('and')) + " ", 1),
        _createVNode(_component_router_link, {
          to: { name: 'privacy-policy' },
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('policies.privacyPolicy')), 1),
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wallets.value, (wallet) => {
        return (_openBlock(), _createBlock(WalletButton, {
          key: wallet,
          wallet: wallet
        }, null, 8, ["wallet"]))
      }), 128)),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h6", null, _toDisplayString(_ctx.$t('newToEthereum')), 1),
        _createElementVNode("p", _hoisted_9, [
          _createTextVNode(_toDisplayString(_ctx.$t('setUpEthereumWallet')) + " ", 1),
          _createVNode(_component_BalLink, {
            href: _unref(EXTERNAL_LINKS).Ethereum.Wallets,
            external: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('learnMore')) + " ", 1),
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_BalIcon, {
                  name: "arrow-up-right",
                  size: "sm"
                })
              ])
            ]),
            _: 1
          }, 8, ["href"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})